import * as Yup from "yup";

import {
  phoneRegex,
    zipRegex,
    stateRegEx,
  dateCantBeInFuture
} from "./validationFunctions";



export const repInfoValidations = (formType, languageText) => {

  if (true && formType.includes('Representative')) {
    return Yup.object().shape({

      RepFName: Yup.string().required(
        () =>
          languageText.ErrorChecking.ValidatorText.FirstName
      ),
      RepLName: Yup.string().required(
        () =>
          languageText.ErrorChecking.ValidatorText.FirstName
      ),
      RepPhone: Yup.string()
        .required(
          () =>
            languageText.ErrorChecking.ValidatorText.FirstName
        )
        .matches(
          phoneRegex,
          languageText.ErrorChecking.ValidatorText.PhoneNumberInvalid
        ),
      Rep_Phone_Conform: Yup.string()
        .required(
          () =>
            languageText.ErrorChecking.ValidatorText.PhoneNumberConfirm
        )
        .oneOf([Yup.ref('RepPhone'), '555'], languageText.ErrorChecking.ValidatorText.PhoneNumberInvalid),
      RepEmail: Yup.string()
        .required(
          () =>
          languageText.ErrorChecking.ValidatorText.Email

        )
        .email(
          languageText.ErrorChecking.ValidatorText.EmailInvalid
        )
        .max(
          50,
          languageText.ErrorChecking.ValidatorText.EmailLong
        ),
      Rep_Email_Conform: Yup.string()
        .required(
            () =>
                languageText.ErrorChecking.ValidatorText.EmailConfirm
        )
        // .oneOf([Yup.ref('RepEmail'), null], 'Email addresses must match'),
        .test(
          'email-match',
          languageText.ErrorChecking.ValidatorText.EmailMatch,
          function (value) {
            const { RepEmail } = this.parent; // Get the value of the RepEmail field
            if (!RepEmail || !value) {
              // If either field is empty, consider them a match
              return true;
            }
            // Compare lowercase versions of the email addresses
            return value.toLowerCase() === RepEmail.toLowerCase();
          }
        ),
      RepAddress1: Yup.string()
        .required(
            () =>
                languageText.ErrorChecking.ValidatorText.MissingAddress
        )
        .max(
          50,
          languageText.ErrorChecking.ValidatorText.AddressTooLong
        ),
      RepAddress2: Yup.string()

        .max(
          50,
          languageText.ErrorChecking.ValidatorText.AddressTooLong
        ),
      RepCity: Yup.string()
        .required(
          () =>
            true &&
          languageText.ErrorChecking.ValidatorText.CityMissing

        )
        .max(
          30,
          languageText.ErrorChecking.ValidatorText.CityLong

        ),
      RepState: Yup.string()
        .required(
          () => {
            // formType.includes('Patient') &&
            return (true &&
              languageText.ErrorChecking.ValidatorText.StateMissing)
            }
        ).matches(stateRegEx, languageText.ErrorChecking.ValidatorText.StateInvalid)
        .max(
          2,
          languageText.ErrorChecking.ValidatorText.StateLong
        ),
      RepMName: Yup.string()
        .max(
          1,
          languageText.ErrorChecking.ValidatorText.MILong
        ),
      rrelationship: Yup.string()
        .required(
          () =>
          languageText.ErrorChecking.ValidatorText.RelationshipMissing
        ),

    

      RepZip: Yup.string()
        .required(
            () =>
                languageText.ErrorChecking.ValidatorText.ZipMissing
        )
        .matches(
          zipRegex,
          languageText.ErrorChecking.ValidatorText.ZipInvalid
        )
    });
  } else { return Yup.object().shape(); }
};



